module.exports = __webpack_public_path__ + "assets/normal/images/ComEmpty_1.25d9227c.png";